import {
  getAirQualityCardKey,
  getAirQualityCardTitle,
} from '../../../features/AirQuality/utils/airQuality.utils';
import { airQualityReportColumnClassNameByLayout } from '../config/airQualityWidget.config';

export const getAirQualityReportColumnClassName = (layout) => {
  return airQualityReportColumnClassNameByLayout[layout] ?? 'row-cols-1';
};

export const getAirQualityStationSelectOptions = (stations = []) => {
  return stations.map(({ stationName }) => ({ value: stationName, label: stationName }));
};

export const getAirQualityObservationStations = (observations = []) => {
  return observations.map((observation) => {
    const stationName = observation?.air_station_name || 'Unknown Station';
    return { stationName, reports: [{ ...observation }] };
  });
};

export const getSelectedAirQualityStation = (stations = [], selectedStationName) => {
  return (
    stations.find((station) => station.stationName === selectedStationName) ?? stations[0] ?? null
  );
};

export const getAirQualityObservationReportItems = (stations = []) => {
  return stations.flatMap(({ stationName, reports = [] }) =>
    reports.map((report, index) => ({
      ...report,
      id: getAirQualityCardKey(report, index),
      title: stationName,
    })),
  );
};

export const getAirQualityForecastReportItems = (station = {}) => {
  return (station?.reports ?? []).map((report, index) => ({
    ...report,
    id: getAirQualityCardKey(report, index),
    title: getAirQualityCardTitle(report),
  }));
};
